module.exports = __webpack_public_path__ + "img/46.16a1264a.jpg";